import s from './style.module.scss'
import CLoseButton from './CloseButton'
import { Display } from '@/components/Display/Display'

import { inject, observer } from 'mobx-react';
const Egg = (props) => {
    let { grtAi } = props.store
    const { eggShow, setEggShow } = grtAi;

    return <>
        <Display show={eggShow}>
            <div className={s.eggWrapper}>
                <div className={s['closeWrapper']} onClick={() => {
                    setEggShow(false)
                }}>
                    <CLoseButton> </CLoseButton>
                </div>
                <iframe style={{ width: '100%', height: '100%' }} src="https://lowcode.grtcloud.net/Fire/index.html" frameBorder="0"></iframe>

            </div>
        </Display>

    </>
}

export default (inject('store')(observer(Egg)));